import { render, staticRenderFns } from "./special-lib-android.vue?vue&type=template&id=2528a82a&scoped=true&"
import script from "./special-lib-android.vue?vue&type=script&lang=ts&"
export * from "./special-lib-android.vue?vue&type=script&lang=ts&"
import style0 from "./special-lib-android.vue?vue&type=style&index=0&id=2528a82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528a82a",
  null
  
)

export default component.exports